// Internal page tags use #eyebrow; Text, or #eyebrow; none to remove the row.
export default function applyHomeEyebrows() {
    document.querySelectorAll("[data-lds-home-eyebrow]").forEach((eyebrow) => {
        const tagList = eyebrow.querySelector("[data-lds-eyebrow-tags]");
        const values = Array.from(tagList?.content.querySelectorAll("[data-tag-name]") || [])
            .map((tag) => tag.dataset.tagName.match(/^#eyebrow\s*;\s*(.+)$/i)?.[1].trim())
            .filter(Boolean);
        // An explicit opt-out wins; otherwise the first valid tag in page order wins.
        if (!values.length || values.some((value) => value.toLowerCase() === "none")) {
            const heading = eyebrow.nextElementSibling;
            if (heading?.matches("h1, h2, h3")) {
                heading.classList.add("lds-ghost-heading-without-eyebrow");
            }
            eyebrow.remove();
        } else {
            eyebrow.textContent = values[0];
            eyebrow.hidden = false;
        }
    });
}
